/**
 * CLI documentation page — command-line interface for managing teammates and running tasks.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { cliContent } from "@/constants/docs/cli";

export const Route = createFileRoute("/docs/cli")({
	component: CliPage,
});

function CliPage() {
	return <DocsPage title="CLI" content={cliContent} />;
}
